import { atom } from 'recoil';

export const atomAlertsCountDisplay = atom({
  key: 'atomAlertsCountDisplay', 
  default: 0, 
});
export default atomAlertsCountDisplay;